// components/Pricing.jsx
import React, { useState } from "react";
import "./Pricing.css";
import { Check } from "lucide-react";

const Pricing = ({ addToCart }) => {
  const [selectedPlan, setSelectedPlan] = useState(2);

  const pricingPlans = [
    {
      id: 1,
      name: "Starter",
      price: "₹10,000",
      period: "per year",
      description: "Perfect for small businesses just getting started",
      features: [
        "Cloud Billing",
        "Unlimited transactions",
        "Unlimited Users",
        "Roles and permissions",
        "Basic inventory management",
        "Single store",
        "Basic reports",
        "On-call / On-chat Support",
      ],
      popular: false,
    },
    {
      id: 2,
      name: "Professional",
      price: "₹15,000",
      period: "per year",
      description: "Ideal for growing businesses with multiple locations",
      features: [
        "Including Starter",
        "Advanced inventory management",
        "Indun support",
        "Advanced analytics",
        "Multi store reports",
        "Customer loyalty program",
      ],
      popular: true,
    },
    {
      id: 3,
      name: "Enterprise",
      price: "₹20,000",
      period: "per year",
      description: "For large businesses with complex needs",
      features: [
        "Everything in Professional",
        "Custom hardware integration",
        "Dedicated account manager",
        "Multi store Indun support",
        "Common stock store support",
        "Custom development",
      ],
      popular: false,
    },
  ];

  const handleSelect = (plan) => {
    setSelectedPlan(plan.id);
  };

  const handleGetStarted = (plan) => {
    addToCart(plan);
  };

  return (
    <section id="pricing" className="section pricing-section">
      <div className="container">
        <h2 className="section-title">
          Simple, <span className="gradient-text">Transparent</span> Pricing
        </h2>
        <p className="section-subtitle">
          Choose the plan that works best for your business. All plans are
          per year per outlet and include a 14-day free trial.
        </p>

        <div className="pricing__grid">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`pricing__card ${
                selectedPlan === plan.id ? "pricing__card--selected" : ""
              } ${plan.popular ? "pricing__card--popular" : ""}`}
              onClick={() => handleSelect(plan)}
            >
              {plan.popular && (
                <div className="pricing__badge">Most Popular</div>
              )}

              <h3 className="pricing__name">{plan.name}</h3>

              <div className="pricing__price">
                <span className="pricing__amount">{plan.price}</span>
                <span className="pricing__period">/{plan.period}</span>
              </div>

              <p className="pricing__desc">{plan.description}</p>

              <ul className="pricing__features">
                {plan.features.map((feature, idx) => (
                  <li key={idx}>
                    <Check size={16} className="pricing__check" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                className={`btn ${
                  plan.popular ? "btn-primary" : "btn-secondary"
                } pricing__btn`}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedPlan(plan.id);
                  handleGetStarted(plan);
                }}
              >
                Get Started
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
